import React, { useEffect, useRef, useState } from "react";
import { animate } from "framer-motion";

/**
 * Animated number counter. Falls back to rendering the raw value verbatim
 * when it is non-numeric (e.g. "—", "20+", "Agentic").
 */
export function AnimatedNumber({ value, duration = 1.1, decimals = 0, className = "" }) {
    const numeric = typeof value === "number" && Number.isFinite(value);
    const [display, setDisplay] = useState(numeric ? 0 : value);
    const prev = useRef(0);

    useEffect(() => {
        if (!numeric) {
            setDisplay(value);
            return;
        }
        const from = prev.current;
        const to = value;
        const controls = animate(from, to, {
            duration,
            ease: [0.22, 1, 0.36, 1],
            onUpdate: (v) => setDisplay(v),
        });
        prev.current = to;
        return () => controls.stop();
    }, [value, numeric, duration]);

    const text = numeric && typeof display === "number" ? display.toFixed(decimals) : display;
    return <span className={className}>{text}</span>;
}
